import {
    useLayoutEffect,
    useEffect,
    useState
} from "react";
import {
    TouchableOpacity,
    ActivityIndicator,
    ScrollView,
    Image,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    PageContainer,
    Text
} from "ncore-ui-kit";
import {
    useNavigation,
} from "@react-navigation/native";
import {
    useSafeAreaInsets
} from "react-native-safe-area-context";
import type {
    AboutPresidentPayloadType
} from "../../../services/restAPI/actions/getAboutPresident/types";
import type AppStackParamList from "../../../types/navigation/app";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";
import {
    ChevronLeft
} from "lucide-react-native";
import {
    RESTService
} from "../../../services/restAPI";

const AboutPresident = () => {
    const navigation = useNavigation<NativeStackNavigationProp<AppStackParamList>>();

    const {
        radiuses,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [data,
        setData] = useState<AboutPresidentPayloadType>();
    const [loading,
        setLoading] = useState(true);

    const inset = useSafeAreaInsets();

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: true,
            header: () => <View
                style={[
                    stylesheet.headerContainer,
                    {
                        backgroundColor: colors.content.container.default,
                        paddingHorizontal: spaces.spacingMd,
                        paddingTop: inset.top
                    }
                ]}
            >
                <TouchableOpacity
                    style={[
                        stylesheet.backButton,
                        {
                            padding: spaces.spacingSm
                        }
                    ]}
                    onPress={() => {
                        navigation.goBack();
                    }}
                >
                    <ChevronLeft
                        size={30}
                    />
                </TouchableOpacity>
                <View
                    pointerEvents="none"
                    style={[
                        stylesheet.headerTitleContainer,
                        {
                            top: inset.top + spaces.spacingSm
                        }
                    ]}
                >
                    <Text
                        variant="titleLargeSize"
                        color="high"
                        style={stylesheet.headerTitle}
                    >
                        {localize("president")}
                    </Text>
                </View>
            </View>
        });
    }, [navigation]);

    useEffect(() => {
        getAboutPresidentData();
    }, []);

    const getAboutPresidentData = () => {
        RESTService.action("GetAboutPresident", null)
            .then((res) => {
                if(res.code === 200 || res.code === 201 || res.code === 202) {
                    setData(res.payload);
                }
                setLoading(false);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setLoading(false);
            });
    };

    const renderInfo = () => {
        return <View
            style={[
                stylesheet.contentContainer,
                {
                    marginTop: spaces.spacingMd,
                    marginBottom: spaces.spacingMd
                }
            ]}
        >
            <Image
                source={{
                    uri: data?.profilePhotoURL
                }}
                style={[
                    stylesheet.presidentImage,
                    {
                        borderRadius: radiuses.md
                    }
                ]}
            />
            <Text
                variant="headlineSmallSize"
                color="high"
                style={{
                    marginTop: spaces.spacingLg
                }}
            >
                {data?.fullName}
            </Text>
            <Text
                variant="titleMediumSize"
                color="low"
                style={{
                    marginTop: spaces.spacingMd
                }}
            >
                {data?.positiom}
            </Text>
            {/* <MarkdownViewer
                content={data?.content || ""}
                style={{
                    marginTop: spaces.spacingSm
                }}
            /> */}
        </View>;
    };

    if(loading) {
        return <PageContainer
            style={stylesheet.loadingContainer}
        >
            <ActivityIndicator
                size={40}
                color={colors.content.icon.default}
            />
        </PageContainer>;
    }

    return <PageContainer
        isScrollable={false}
        style={stylesheet.container}
    >
        <ScrollView
            style={stylesheet.flex1}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
        >
            {renderInfo()}
        </ScrollView>
    </PageContainer>;
};
export default AboutPresident;
